import { render, staticRenderFns } from "./zTextField.vue?vue&type=template&id=31970be0&scoped=true&"
import script from "./zTextField.vue?vue&type=script&lang=js&"
export * from "./zTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31970be0",
  null
  
)

export default component.exports